import React from 'react';

import ContentfulAsset from 'brand/app/contentful/classes/ContentfulAsset';
import Picture from 'brandComponents/Picture';

import {IAssetProps} from './IAsset';

const Asset = (props: IAssetProps) => {
	const image = new ContentfulAsset(props);

	return (
		<Picture
			image={image}
			showSkeleton={false}
			showPlaceholder={true}
			classNames={props.classNames}
			threshold={props.threshold}
			printTitle={false}
		/>
	);
};

export default Asset;
